<template>
   <main class="main-container">
      <div class="main-overlay">
         <slot/>
      </div>
   </main>
</template>